<template>
  <main>
    <NavMenu>
      <NavItem name="首页" path="/home" />
      <NavItem name="本站分类法" active />
    </NavMenu>
    <article class="mid-tab">
      <ul class="flex-tabs">
        <li
          @click="handleChangeClassifyType('clc')"
          :class="[classifyType == 'clc' ? 'actived' : 'default']"
        >
          中国图书馆分类法
        </li>
        <li
          @click="handleChangeClassifyType('subject')"
          :class="[classifyType == 'subject' ? 'actived' : 'default']"
        >
          学科分类法
        </li>
      </ul>
      <template v-if="classifyType == 'clc'">
        <p class="classinfo">
          《中国图书馆分类法》简称《中图法》，1975年《中图法》由科学技术文献出版社出版第1版，2010年国家图书馆出版社出版第5版，
          是我国图书馆和情报单位普遍使用的一部综合性的分类法。
        </p>
        <p class="classinfo">
          《中图法》包括马列主义、毛泽东思想，哲学，社会科学，自然科学，综合性图书五大部类，A-Z共22个基本大类。《中图法》使用英文字母与数字相结合的混合号码，基本采用层累制编号法，用一个字母代表一个大类，以字母顺序反映大类的次序，大类下细分的学科门类用阿拉伯数字组成。
        </p>
      </template>
      <template v-else>
        <p class="classinfo">
          《学科分类法》主要依据教育部国务院学位委员会印发的《学位授予和人才培养学科目录（2018）》（以下简称新目录）制定。为适应我国经济、社会、科技和高等教育的发展，国务院学位委员会、教育部启动了学科目录修订工作，对学科目录设置与管理的机制进行了改革。新目录适用于硕士、博士的学位授予、招生和培养，并用于学科建设和教育统计分类等工作。学士学位按新目录的学科门类授予
        </p>
        <p class="classinfo">
          我国高等学校研究生教育专业设置按“学科门类”、“学科大类（一级学科）”、“专业”（二级学科）三个层次来设置。新目录设置13大学科门类，分别为哲学、经济学、法学、教育学、文学、历史学、理学、工学、农学、医学、军事学、管理学、艺术学。每个学科门类下设置若干学科大类（一级学科），一级学科再下设若干二级学科，如数学（一级学科）下设基础数学、计算数学等5个二级学科。博士、硕士学位就授至二级学科。
        </p>
      </template>
    </article>
    <section class="mid-tree">
      <header class="title">
        {{ classifyType == 'clc' ? '中国图书馆分类法 第五版' : '学科分类法' }}
      </header>
      <el-tree :data="treeData" :props="defaultProps" accordion :load="loadNode" lazy>
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="treename">
            {{ node.label }}
            <span class="treeresult">({{ data.result }})</span>
          </span>

          <span class="btnspan" @click="() => handleViewAllResources(node, data)">
            查看全部资料
          </span>
        </span>
      </el-tree>
    </section>
  </main>
</template>

<script>
export default {
  name: 'searchresult',
  data() {
    return {
      subjectTreeData: [],
      clcTreeData: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      classifyType: 'clc',
      searchword: '',
      pagesize: 10,
      pageno: 1,
      all_count: '',
      total: 1000,
      filter: [],
      aggleft: true,
      recordlist: [],
      serverdata: {
        left: [],
      },
      customercode: '',
    }
  },
  created() {
    this.customercode = localStorage.getItem('customerCode')
    this.getClcSubjectData()
  },
  mounted() {
    this.getquery()
    if (sessionStorage.getItem('keyword')) {
      var param = [
        {
          logicalop: 'and',
          fieldname: '10100001,10110001,10120001',
          relationop: 'like',
          word: sessionStorage.getItem('keyword'),
        },
      ]
      this.filter = param
    }
    this.getsearchresult(this.filter)
  },
  methods: {
    handleViewAllResources(node, data) {
      let filters = {
        search: [
          {
            title: '自定义条件',
            name: '',
            fieldname: '',
            relationop: 'group',
            children: [],
            advanced: true,
          },
        ],
        left: [],
        top: [
          {
            word: '',
            fieldname: '',
            logicalop: 'and',
            relationop: 'group',
            type: this.classifyType,
            title: this.classifyType == 'clc' ? '中图法分类' : '学科分类',
            children: data.filterfield,
            name: data.name,
            advanced: true,
          },
        ],
        date: [],
      }
      sessionStorage.setItem('searchFilter', JSON.stringify(filters))
      this.$router.push({
        name: 'BookList',
        params: { from: 'classify' },
      })
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.classifyType == 'clc') {
          this.treeData = this.clcTreeData
        } else {
          this.treeData = this.subjectTreeData
        }
        return resolve(this.treeData)
      }
      this.$http({
        url:
          '/api/v1/datasearch/clc_subject_count?pageno=0&pagesize=10&orderfield=10100001&ordertype=D' +
          node.data.urlappend,
        method: 'post',
        data: {
          filter: node.data.filterfield,
        },
      }).then((res) => {
        if (res.returnvalue.left && res.returnvalue.left.length > 0) {
          res.returnvalue.left.forEach((element) => {
            if (
              element.name.indexOf('图') != -1 &&
              element.items &&
              element.items.length > 0
            ) {
              // this.clcTreeData=element.items[0].items
              if (this.classifyType == 'clc') {
                if (element.items[0].items) {
                  resolve(element.items[0].items)
                } else {
                  return resolve([])
                }
              }
            } else if (
              element.name.indexOf('学科') != -1 &&
              element.items &&
              element.items.length > 0
            ) {
              // this.subjectTreeData=element.items[0].items
              if (this.classifyType == 'subject') {
                if (element.items[0].items) {
                  resolve(element.items[0].items)
                } else {
                  return resolve([])
                }
              }
            }
          })
        }
      })
    },
    getClcSubjectData() {
      this.$http({
        url: '/api/v1/datasearch/clc_subject_count?pageno=0&pagesize=10&orderfield=10100001&ordertype=D',
        method: 'post',
        data: {},
      }).then((res) => {
        if (res.returnvalue.left && res.returnvalue.left.length > 0) {
          res.returnvalue.left.forEach((element) => {
            if (
              element.name.indexOf('图') != -1 &&
              element.items &&
              element.items.length > 0
            ) {
              this.clcTreeData = element.items[0].items
            } else if (
              element.name.indexOf('学科') != -1 &&
              element.items &&
              element.items.length > 0
            ) {
              this.subjectTreeData = element.items[0].items
            }
          })
          this.treeData = this.clcTreeData
        }
      })
    },
    handleChangeClassifyType(val) {
      this.classifyType = val
      if (val == 'clc') {
        this.treeData = this.clcTreeData
      } else {
        this.treeData = this.subjectTreeData
      }
    },
    //首次进入检索条件获取
    getquery() {
      var searchword = this.$route.query.searchword
      this.searchword = searchword
    },
    //资料获取
    getsearchresult(filterdata) {
      if (!filterdata) {
        filterdata = this.filter
      }
      var initfilter = { filter: filterdata }
      var pageno = this.pageno - 1
      this.$http({
        url: `/api/v1/customer/search/home_search?pageno=` + pageno + `&pagesize=10`,
        method: 'POST',
        data: initfilter,
      }).then((res) => {
        if (res.cxajaxrc == 0 || res.cxajaxrc == '0') {
          if (this.aggleft) {
            this.serverdata.left = res.returnvalue.left
          }
          this.recordlist = res.returnvalue.recordlist
          this.total = res.returnvalue.recordcount
          this.all_count = res.returnvalue.recordcount
          if (this.total > 10000) {
            this.total = 10000
          }
        } else {
          this.$message.error(res.cxajaxerrmsg)
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
main {
  width: 1200px;
  align-self: center;
  margin-bottom: 50px;
}
/deep/ .el-tree-node__content {
  height: 50px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .btnspan {
    cursor: pointer;
    user-select: none;
    font-size: 18px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    text-align: justifyLeft;
    color: $mainColor;
    line-height: 36px;
    display: none;
  }
  &:hover {
    .btnspan {
      display: block;
    }
  }
}
.mid-tab {
  background: #f1f9fe;
  box-shadow: $mainShadow;
  padding: 30px 100px;
  .default {
    width: 200px;
    height: 48px;
    background: #ffffff;
    border: 1px solid $mainColor;
    font-size: 18px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    text-align: center;
    color: $mainColor;
    line-height: 48px;
    user-select: none;
    cursor: pointer;
    &:hover {
      width: 200px;
      height: 48px;
      background: $mainColor;
      border: 1px solid $mainColor;
      text-align: center;
      color: #fffefe;
      line-height: 48px;
      user-select: none;
      cursor: pointer;
    }
  }
  .flex-tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 28px;
    li {
      list-style: none;
      font-size: 18px;
    }
  }
  .actived {
    width: 200px;
    height: 48px;
    background: $mainColor;
    border: 1px solid $mainColor;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    text-align: center;
    color: #fffefe;
    line-height: 48px;
    user-select: none;
    cursor: pointer;
  }
  .classinfo {
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-size: 18px;
    line-height: 36px;
    color: #666;
    text-indent: 2em;
  }
}
.mid-tree {
  background: #ffffff;
  box-shadow: $mainShadow;
  padding: 30px 100px;
  margin-top: 20px;
  overflow-y: auto;
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
    font-weight: 700;
    text-align: justifyLeft;
    color: #333333;
    padding-bottom: 30px;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 30px;
  }
  .treename {
    font-size: 18px;
    font-family: Arial, Arial-Regular;
    font-weight: 400;
    text-align: justifyLeft;
    color: #333333;
    line-height: 36px;
  }
  .treeresult {
    color: #999;
  }
}
</style>
